import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner4 from '../../assets/banner4.png'

import { Container, Title, Content, Table } from './styles'

export function Servicos() {
 const title = 'Serviços'

 const fields = useMemo(
  () => [
   {
    id: 'Serviços',
    imagem: String,
    title: String,
    text: String,
    status: Number
   }
  ],
  []
 )

 const {
  servicos,
  setServicos,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(servicos.length / limit)

 const loadServicos = useCallback(async () => {
  try {
   const response = await api.get('servicos')

   setServicos(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar os serviços')
  }
 }, [setServicos])

 useEffect(() => {
  loadServicos()
 }, [loadServicos])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadServicos}
     fields={fields}
     name="servicos"
     title="Serviço"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadServicos}
     id={id}
     name="servicos"
     title="Serviço"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadServicos}
     id={id}
     name="servicos"
     folder="servicos"
     title="Serviço"
    />
   )}

   <Header title={title} />

   <Container>
    <Title>Gerenciador de Tópicos</Title>
    {servicos.length <= 0 ? (
     <>Nenhum serviço cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <td>Exibição</td>
         <td>Imagem</td>
         <td>Título</td>
         <td>Status</td>
         <td colSpan="2"></td>
        </tr>
       </thead>
       <tbody>
        {servicos &&
         servicos.slice(offset, offset + limit).map(servico => (
          <tr key={servico.id}>
           <td>{servico.id}</td>
           <td>
            <div className="servicos">
             {servico.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/servicos/${servico.file}`}
               alt={servico.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{servico.title}</td>
           <td>
            {servico.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(servico.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(servico.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações dos icones</Title>
    <Content>
     <div>
      <img src={banner4} alt="icones" />
      <h3>Ícones</h3>
      <p>Formato: 54 x 54 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
